// extracted by mini-css-extract-plugin
export default {"container":"category-page_container__21hXP","filters":"category-page_filters__28nWo"};